import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import JotrFields from 'components/Customer/JotrFields';
import { change, FormSection, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import {
  openAddCustomerJotrModal,
  closeAddCustomerJotrModal,
  changePrimaryJotr
} from 'actions';
import AddCustomerJotrModal from 'components/Customer/AddCustomerJotrModal';
import ConfirmModal from 'components/Modals/ConfirmModal';

const CustomerJotrsPanel = ({ taxResidencies, isEditingCustomer, jurisdictions, dispatch,
  isAddCustomerJotrModalShown, dataSource
}) => {
  const [toggle, setToggle] = useState(true);
  const [showMakePrimaryConfirmModal, setShowMakePrimaryConfirmModal] = useState(false);
  const [jotrIndex, setJotrIndex] = useState(0);

  const handleSetToggle = () => {
    setToggle(prevState => !prevState);
  };

  const showAddJotrModal = () => {
    dispatch(openAddCustomerJotrModal());
  };
  const closeAddJotrModal = () => dispatch(closeAddCustomerJotrModal());

  const hasTaxResidences = taxResidencies && taxResidencies.length > 0;

  const localTaxResidencies = [...taxResidencies || []];

  const onSubmitMakePrimary = () => {
    dispatch(changePrimaryJotr(localTaxResidencies[jotrIndex]?.customerId, localTaxResidencies[jotrIndex]?.id));
    setShowMakePrimaryConfirmModal(false);
  };

  const handleRemoveTaxResidence = (index) => {
    localTaxResidencies.splice(index, 1);
    dispatch(change('customerEditForm', 'taxResidencies', localTaxResidencies));
  };

  const handleChangeWhdResidence = (index) => {
    for (let i = 0; i < localTaxResidencies.length; i += 1) {
      dispatch(
        change('customerEditForm', `${ 'taxResidencies' }[${ i }].isWithholdingResidence`, i === index)
      );
    }
  };

  const handleMakePrimaryClick = (index) => {
    if (dataSource === 'form') {
      setJotrIndex(index);
      setShowMakePrimaryConfirmModal(true);
      return;
    }

    if (isEditingCustomer) {
      for (let i = 0; i < localTaxResidencies.length; i += 1) {
        dispatch(
          change('customerEditForm', `taxResidencies[${ i }].isPrimary`, i === index)
        );
      }
    }
  };

  return (
    <div className="customer-collapsible-panel">
      <div className="inline-header-dropdown">
        { hasTaxResidences
        && <button
          type="button"
          className="btn panel-data-toggle-button"
          onClick={ handleSetToggle }
          title={ `${ toggle ? 'Hide' : 'Show' } Addresses` }
          id="customer-jotr-toggle"
        >
          <span className={ `icon icon-arrow-${ toggle ? 'up' : 'down' }` } />
        </button>}
        <h2 id="customer-jotrs-header"><strong>Tax Residences:</strong></h2>
        {isEditingCustomer && <button
          type="button"
          className="btn btn-add-address"
          onClick={ () => showAddJotrModal() }
          disabled={ localTaxResidencies.length > 9 }
          title={ localTaxResidencies.length > 9 ? 'You can add up to 10 tax residences' : 'Add tax residence' }
          id="add-jotr-button"
        >+ Add Tax Residence
        </button>}
      </div>
      <div className={ toggle ? 'panel-data' : 'hide' } id="customer-jotr-data">
        <div className="data-grid">
          {localTaxResidencies?.map((curTaxRes, index) => (curTaxRes
        && <div key={ `taxResidence-${ index + 1 }` }>
          <FormSection
            name={ `taxResidencies[${ index }]` }
            component={ JotrFields }
            isEditable={ isEditingCustomer }
            index={ index }
            isWithholdingResidence={ curTaxRes?.isWithholdingResidence }
            isPrimary={ curTaxRes?.isPrimary }
            jurisdictions={ jurisdictions }
            onRemoveTaxResidence={ handleRemoveTaxResidence }
            onChangeWhdResidence={ handleChangeWhdResidence }
            onMakePrimaryClick={ handleMakePrimaryClick }
            isPrimaryEditable={ dataSource === 'form' }
          />
          </div>
          )) }
        </div>
      </div>
      {isAddCustomerJotrModalShown && <AddCustomerJotrModal
        onCancel={ closeAddJotrModal }
        isAddJotrModalShown={ isAddCustomerJotrModalShown }
        prevAddresses={ localTaxResidencies }
        jurisdictions={ jurisdictions }
        isPrimary={ localTaxResidencies.length === 0 }
      />}
      {showMakePrimaryConfirmModal && <ConfirmModal
        key="confirmMakePrimaryJotr"
        isShown={ showMakePrimaryConfirmModal }
        onConfirm={ () => onSubmitMakePrimary() }
        onCancel={ () => setShowMakePrimaryConfirmModal(false) }
        title="Switch Primary Tax Residence"
        message="Are you sure you want to switch the Primary Tax Residence?"
      />}
    </div>
  );
};

CustomerJotrsPanel.propTypes = {
  taxResidencies: PropTypes.arrayOf(PropTypes.shape()),
  isEditingCustomer: PropTypes.bool,
  jurisdictions: PropTypes.arrayOf(PropTypes.shape()),
  dispatch: PropTypes.func.isRequired,
  isAddCustomerJotrModalShown: PropTypes.bool,
  dataSource: PropTypes.string.isRequired
};

CustomerJotrsPanel.defaultProps = {
  jurisdictions: null,
  isEditingCustomer: false,
  taxResidencies: null,
  isAddCustomerJotrModalShown: false
};

const selector = formValueSelector('customerEditForm');

const mapStateToProps = state => ({
  taxResidencies: selector(state, 'taxResidencies'),
  isAddCustomerJotrModalShown: state?.customer?.isAddCustomerJotrModalShown
});

export default connect(mapStateToProps)(CustomerJotrsPanel);
